// Module
var code = `<div class="btn-spinner" ng-if="!\$ctrl.htmlform"></div> <div id="{{\$ctrl.formname}}" ng-bind-html="\$ctrl.htmlform | unsafe" ng-if="\$ctrl.htmlform"></div>`;
// Exports
module.exports = code;